var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumb",class:{'gray': _vm.isGray},style:(_vm.thumbStyle)},[_c('div',{staticClass:"thumb-img",class:_vm.imageStyle,style:({ backgroundImage: 'url(' + _vm.thumbSrc + ')' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }